module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-logo-branding.487020e9.jpg";